import React from 'react';

const openLocalizerPopup = (event) => {
  event.preventDefault();

  const myStoreButton = document.querySelector('#myStore .MyStore__button')
    // mw
    || document.querySelector('.MyStore__button.MyStore--inline__button');

  if (myStoreButton) {
    myStoreButton.click();
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  } else {
    console.log('#myStore button not found in header');
  }
};

export const NotLocalized = () => (
  <div className="store__new-line">
    {/* eslint-disable-next-line */}
    <a
      onClick={openLocalizerPopup}
      href="#"
      className="u__default-link"
    >
      Set your store
    </a> to see local availability
  </div>
);
